<template>
  <div>
    <b-row>
      <b-col style="text-align: -webkit-center">
        <input
          type="file"
          @change="onChange"
          id="xmlListForExcel"
          ref="fileInput"
          :disabled="!isValidateLocal"
        />
        <label
          :class="{ 'custom-file-upload': true, 'is-uploaded': isUploadedLocal }"
          for="xmlListForExcel"
        >
          <Icon icon="ep:upload-filled" width="30" height="30" />
          <span>{{ isUploadedLocal ? $t("FileUploaded") : $t("UploadFile") }}</span>
        </label>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
import XLSX from "xlsx";

export default {
  props: {
    isUploaded: {
      type: Boolean,
      required: true,
    },
    uploadMethod: "",
    isValidate: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      wholeStockList: [],
    };
  },
  components: { Icon },
  watch: {
    uploadMethod(val) {
      return val;
    },
    isUploaded(val) {
      return val;
    },
    isValidate(val) {
      return val;
    },
  },
  computed: {
    isValidateLocal: {
      get() {
        return this.isValidate;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isUploadedLocal: {
      get() {
        return this.isUploaded;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
  },
  methods: {
    onChange(e) {
      let method =
        typeof this.uploadMethod == "undefined" ? "excelData" : this.uploadMethod;
      try {
        const vm = this;
        vm.wholeStockList = [];
        var files = e.target.files,
          f = files[0];
        var reader = new FileReader();
        reader.onload = function (e) {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, { type: "array", cellDates: true });
          let sheetName = workbook.SheetNames[0];
          let worksheet = workbook.Sheets[sheetName];
          vm.wholeStockList = XLSX.utils.sheet_to_json(worksheet);
          vm.isUploadedLocal = true;
          vm.$root.$emit(method, vm.wholeStockList);
          //     vm.setItems();
        };
        reader.readAsArrayBuffer(f);
        e.target.value = "";
        this.$refs.fileInput.value = null;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss">
.file-upload-container {
  display: inline-block;
  position: relative;
}

input[type="file"] {
  display: none;
}

.custom-file-upload {
  width: 150px;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f9f9f9;
  color: #777;
  border: 2px dashed #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.custom-file-upload:hover {
  background-color: #f1f1f1;
  border-color: #ccc;
}

.upload-icon {
  font-size: 48px;
  margin-bottom: 10px;
}

/* Dosya yüklendikten sonra uygulanacak stil */
.is-uploaded {
  background-color: #17c3b2;
  color: white;
  border-color: #17c3b2;
}

.is-uploaded .upload-icon {
  color: white;
}
</style>
